import React, { useState, forwardRef } from "react";
import { Dropdown, IDropdownProps } from "./dropdown";
const { StateAbbrevations } = require('domuso-constants').states;

export const USStateDropdown = forwardRef((props: IDropdownProps, ref: any) => {
  const { setValue, formName, errors, inputAccessoryViewID, onFocus, onSubmitEditing } = props;
  const [selectedType, setSelectedType] = useState<any>(null);

  const onSelectHandler = (value) => {
    setValue(value);
    setSelectedType(value);
  };

  return (
    <Dropdown
      onSelectHandler={onSelectHandler}
      value={selectedType}
      label="Select state..."
      items={StateAbbrevations.map((value) => ({ value, label: value }))}
      width={100}
      height={50}
      formName={formName}
      errors={errors}
      inputAccessoryViewID={inputAccessoryViewID}
      onFocus={onFocus}
      onSubmitEditing={onSubmitEditing}
      ref={ref}
    />
  );
});
